<template>
  <div class="order-detail-overview padded-container">
    <div class="row">
      <div class="small-12 column">
        <order-status-graph :order-status="orderStatus"></order-status-graph>
      </div>
    </div>
    <div class="row">
      <div class="small-5 medium-3 large-2 column">{{$t('order.label.order-number')}}</div>
      <div class="small-7 medium-9 large-10 column"><strong>{{orderNumber}}</strong></div>
    </div>
    <div class="row" v-if="orderRef">
      <div class="small-5 medium-3 large-2 column">{{$t('order.label.customer-reference')}}</div>
      <div class="small-7 medium-9 large-10 column"><strong>{{orderRef}}</strong></div>
    </div>
    <div class="row">
      <div class="small-5 medium-3 large-2 column">{{$t('order.label.order-date')}}</div>
      <div class="small-7 medium-9 large-10 column"><strong>{{formatDate(orderDate)}}</strong></div>
    </div>
    <div class="row delivery-date">
      <div class="small-5 medium-3 large-2 column">{{$t('order.label.estimed-delivery-date')}}</div>
      <div class="small-7 medium-9 large-10 column">
        <div>
          <span v-if="orderDeliveryFrom && !orderDeliveryTo">{{ $t('order.label.estimed-delivery-date-on', {onDate: formatDate(orderDeliveryTo)}) }}</span>
          <span v-if="orderDeliveryFrom && orderDeliveryTo">{{ orderDeliveryDate(orderDeliveryFrom, orderDeliveryTo) }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import moment from 'moment'
  import OrderStatusGraph from 'components/OrderStatusGraph'

  function formatDate (date) {
    return date ? moment(date).format('DD.MM.YYYY') : null
  }

  export default {
    name: 'order-detail-overview',
    props: [
      'order-number',
      'order-ref',
      'order-date',
      'order-status',
      'order-cancellation-date',
      'order-delivery-from',
      'order-delivery-to'
    ],
    computed: {
      colorClass: function () {
        return this.$store.state.statusColor[this.status]
      },
      text: function () {
        return this.$t('orders.status["' + this.status + '"]')
      }
    },
    methods: {
      formatDate: formatDate,
      orderDeliveryDate: function (deliveryDateFrom, deliveryDateTo) {
        if (deliveryDateFrom === deliveryDateTo) {
          return this.$t('order.label.estimed-delivery-date-on', { onDate: formatDate(deliveryDateFrom) })
        }
        else {
          return this.$t('order.label.estimed-delivery-date-from-to', { fromDate: formatDate(deliveryDateFrom), toDate: formatDate(deliveryDateTo) })
        }
      }
    },
    components: {
      'order-status-graph': OrderStatusGraph
    }
  }
</script>

<style scoped lang="scss" rel="stylesheet/scss">
  @import '~scss/variables';

  .order-detail-overview {
    background-color: $grey-10;

    padding-top: 20px;
    padding-bottom: 20px;
    line-height: 1.5;

    .order-status-graph {
      margin-bottom: 15px;
    }

    &.in-progress {
      background-color: $success-light;
    }
    &.partial-shipment {
      background-color: $success-medium;
    }
    &.shipped {
      background-color: $success-strong;
    }
    &.canceled {
      background-color: $danger;
    }
  }
</style>



// WEBPACK FOOTER //
// OrderDetailOverview.vue?2779c3c3